module.exports = __webpack_public_path__ + "img/ewm1.08c78173.png";